/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoanCarBookingSubmitModel } from '../models/LoanCarBookingSubmitModel';
import type { LoanCarBookingUpdateModel } from '../models/LoanCarBookingUpdateModel';
import type { LoanCarCheckInDto } from '../models/LoanCarCheckInDto';
import type { LoanCarCheckInSubmitModel } from '../models/LoanCarCheckInSubmitModel';
import type { LoanCarCheckOutDto } from '../models/LoanCarCheckOutDto';
import type { LoanCarConditionCheckSubmitModel } from '../models/LoanCarConditionCheckSubmitModel';
import type { LoanCarDamagePhotoSubmitModel } from '../models/LoanCarDamagePhotoSubmitModel';
import type { LoanCarDamagesModel } from '../models/LoanCarDamagesModel';
import type { LoanCarFilterStatus } from '../models/LoanCarFilterStatus';
import type { LoanCarFixDamageModel } from '../models/LoanCarFixDamageModel';
import type { LoanCarHistoryModel } from '../models/LoanCarHistoryModel';
import type { LoanCarStatus } from '../models/LoanCarStatus';
import type { LoanCarTableDto } from '../models/LoanCarTableDto';
import type { LoanCarWipInfoModel } from '../models/LoanCarWipInfoModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LoanCarService {

  /**
   * @param status
 *
 * 0 = All
 *
 * 1 = CheckedIn
 *
 * 2 = CheckedOut
   * @param branch 
   * @param regNo 
   * @param dateFrom 
   * @returns LoanCarTableDto Success
   * @throws ApiError
   */
  public static getLoanCar(
status?: LoanCarFilterStatus,
branch?: number,
regNo?: string,
dateFrom?: string,
): CancelablePromise<LoanCarTableDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car',
      query: {
        'Status': status,
        'Branch': branch,
        'RegNo': regNo,
        'DateFrom': dateFrom,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postLoanCarCheckIn(
requestBody?: LoanCarCheckInSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/check-in',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param status
 *
 * 0 = Available
 *
 * 1 = CheckedOut
 *
 * 2 = Booked
   * @returns boolean Success
   * @throws ApiError
   */
  public static postLoanCarChangeStatus(
id: number,
status?: LoanCarStatus,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/change-status/{id}',
      path: {
        'id': id,
      },
      query: {
        'status': status,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postLoanCarCheckOut(
requestBody?: LoanCarCheckInSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/check-out',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postLoanCarCheckOutAtp(
id: number,
requestBody?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/check-out/{id}/atp',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static putLoanCarCheckOut(
id: number,
requestBody?: LoanCarCheckInSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/loan-car/check-out/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns LoanCarCheckOutDto Success
   * @throws ApiError
   */
  public static getLoanCarCheckOut(
id: number,
): CancelablePromise<LoanCarCheckOutDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/check-out/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postLoanCarConditionCheck(
id: number,
requestBody?: LoanCarConditionCheckSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/condition-check/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postLoanCarDamagePhoto(
id: number,
requestBody?: LoanCarDamagePhotoSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/damage-photo/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns LoanCarCheckInDto Success
   * @throws ApiError
   */
  public static getLoanCarCheckIn(
id: number,
): CancelablePromise<LoanCarCheckInDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/check-in/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param wipNo 
   * @returns LoanCarWipInfoModel Success
   * @throws ApiError
   */
  public static getLoanCarWipInfo(
wipNo?: number,
): CancelablePromise<LoanCarWipInfoModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/wip-info',
      query: {
        'wipNo': wipNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns LoanCarDamagesModel Success
   * @throws ApiError
   */
  public static getLoanCarDamage(
id: number,
): CancelablePromise<LoanCarDamagesModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/damage/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postLoanCarDamageFix(
id: number,
requestBody?: LoanCarFixDamageModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/damage/fix/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns LoanCarHistoryModel Success
   * @throws ApiError
   */
  public static getLoanCarHistory(
id: number,
): CancelablePromise<LoanCarHistoryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/history/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns LoanCarHistoryModel Success
   * @throws ApiError
   */
  public static getLoanCarHistoryRec(
id: number,
): CancelablePromise<LoanCarHistoryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/history/rec/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postLoanCarSmsCode(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/sms-code/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param code 
   * @returns any Success
   * @throws ApiError
   */
  public static getLoanCarSmsCode(
id: number,
code?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/sms-code/{id}',
      path: {
        'id': id,
      },
      query: {
        'code': code,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static getLoanCarEmail(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/loan-car/email/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postLoanCarEmail(
id: number,
requestBody?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/email/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Book Loan Car
   * @param requestBody Loan Car parameters for booking creation
   * @returns any Created
   * @throws ApiError
   */
  public static postLoanCarBook(
requestBody?: LoanCarBookingSubmitModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/loan-car/book',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Update Loan Car Booking
   * @param id Loan Car booking id (Demobook id)
   * @param requestBody Loan Car parameters for booking update
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchLoanCarBook(
id: number,
requestBody?: LoanCarBookingUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/loan-car/book/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Delete Loan Car Booking
   * @param id Loan Car booking id (Demobook id)
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteLoanCarBook(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/loan-car/book/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
